import React from 'react';
import styles from './UploadBox.module.css';
import { FiUploadCloud } from 'react-icons/fi';

const UploadBox = ({
  onChange,
  label = 'Label',
  innerLabel = 'Inner Label',
}) => {
  return (
    <>
      <p className={styles.Namelabel}>{label}</p>
      <div className={styles.UploadBox}>
        <label htmlFor="fileUpload" className={styles.label}>
          <FiUploadCloud className={styles.icon} />
          <span>{innerLabel}</span>
          <input
            type="file"
            id="fileUpload"
            className={styles.input}
            onChange={onChange}
          />
        </label>
      </div>
    </>
  );
};

export default UploadBox;
